module.exports = __webpack_public_path__ + "img/Copy.d733194c.svg";